<template>
  <div class="login-page">
      <div class="login-div login-container m-router-view">
        <h1 class="system-title" >
          <img src="../assets/logo.png" style="height: 40px; vertical-align: middle;">
          凌恩商务管理系统</h1>
        <el-form label-position="left" :model="loginForm" :rules="loginRules" ref="loginForm" label-width="60px"
                   prefix-icon="el-icon-user"
                   @submit.native.prevent
                   class="login-form">
            <el-form-item label="账号" prop="username">
              <el-input type="text" v-model="loginForm.username" auto-complete="off"
                        placeholder="请输入用户名/手机号/邮箱"></el-input>
            </el-form-item>
            <el-form-item prop="password" label="密码">
              <el-input type="password" v-model="loginForm.password" auto-complete="off"
                        placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item label="记住我" class="form-item-remember">
              <div style="display: flex;justify-content: space-between">
                <div>
                  <el-switch
                      v-model="rememberUsernamePwd"
                      active-color="#13ce66"
                      inactive-color="#ff4949">
                  </el-switch>
                </div>
                <div>
                </div>
              </div>
            </el-form-item>
            <el-form-item style="width:80%;">
              <el-button type="primary" style="width:100%;" native-type="submit" @click="submitForm('loginForm')">
                登录
              </el-button>
            </el-form-item>
        </el-form>
      <p style="font-size: 13px;color: #9b9b9f"><i class="el-icon-info"></i>温馨提示：为保障您的使用体验，请使用最新版chrome浏览器进行访问，其他浏览器可能会影响展示效果。</p>
    </div>
    <CopyrightIcp></CopyrightIcp>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
import {login} from "@/api/dilivery";
import {getDataInLocalStorage, removeDataInLocalStorage, saveDataToLocalStorage} from "@/utils/localStorage";
import CopyrightIcp from '@/components/copyright-icp.vue';
import {getEvaluators} from "@/api/dilivery/customer/person";
import {saveUserAccount} from "@/utils/jsencrypt";
import { isMobile, setModeFlag } from "@/utils/index";

export default {
  components: {CopyrightIcp},
  data() {
    return {
      accountSaveKey: 'accountInfo',
      rememberUsernamePwd: true,
      //账号登录表单
      loginForm: {
        username: '',
        password: ''
      },
      // 账号登录表单验证
      loginRules: {
        username: [{required:true,message:'不能为空', trigger: 'blur'}],
        password: [{required:true,message:'不能为空', trigger: 'blur'}]
      }
    }
  },
  mounted() {
    this.getUserInfoByUrl()
  },
  watch: {

  },
  methods: {
    /**
     * 登录功能
     */
    //通过url获取是否从用户管理系统点击或者是邮件，从而实现账户自动填充，没有的话则获取localStorage的值
    getUserInfoByUrl() {
        const param = this.$route.query
        let username = param.user
        let password = param.pwd
        const withCode = param.withCode
        if (withCode) {
          let accountInfo = CryptoJS.AES.decrypt(decodeURIComponent(withCode), "personal_accountInfo").toString(CryptoJS.enc.Utf8)
          if (accountInfo) {
            accountInfo = JSON.parse(accountInfo)
            username = accountInfo.username
            password = accountInfo.password
          }
        }
        if (username && password) {
          this.activeTabName='pass'
          removeDataInLocalStorage("token")
          this.$store.commit('right/setUser', '')
          this.loginForm = {
            username: username,
            password: password,
          }
        } else {
          this.getLocalStorage()
        }
    },
    //获取存储在本地的账户信息
    getLocalStorage() {
      const accountJson = getDataInLocalStorage(this.accountSaveKey);
      if (accountJson) {
        const accountInfo = JSON.parse(accountJson);
        this.loginForm.username = accountInfo.username
        this.loginForm.password = accountInfo.password
      }
    },
    // 点击账号登录页面的登录按钮
    submitForm(formName) {
      const that = this;
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          that.login(formName);
        }
      })
    },
    //点击登录按钮（账号登录）
    async login(formName) {
      let userData = {
        username: this.loginForm.username,
        password: this.loginForm.password
      }
      let sendData=await saveUserAccount( userData,this.rememberUsernamePwd,this.accountSaveKey)
      sendData.original=false
      login(sendData).then(res => {
        if (res) {
          if (res.data.code === 200) {
            saveDataToLocalStorage('uuid', res.data.data['personUuids'][0])
            let targetRoute = ''
            const role = res.data.data['roles'][0]
            setModeFlag(role)
            if (isMobile()) {
              targetRoute = 'Contract'
            } else {
              if (['ADMIN', 'MANAGER', 'APPROVAL_SPECIALIST'].includes(role)) {
                targetRoute = '/contractCheck'
              } else if (role === 'BUSINESS_COMMERCIAL') {
                targetRoute = '/refundInfo'
              } else if (['SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES','AUDITOR'].includes(role)) {
                targetRoute = '/salesContract';
              } else if (['FINANCE', 'CASHIER'].includes(role)) {
                targetRoute = '/paymentInfo';
              } else if (['LAB', 'TECH'].includes(role)) {
                targetRoute = '/lexicon'
              } else if (['ANALYSE'].includes(role)) {
                targetRoute = '/template'
              }
            }
            this.$message.success("登录成功!");
            this.saveUserInfo(res,targetRoute)
          } else {
            this.$message.error(res.data.message);
            this.loginForm.password = ''
          }
        }
      }).catch((err) => {
      })
    },
    async saveUserInfo(res,targetRoute) {
      try {
        this.$store.commit("right/setRole", res.data.data['roles'][0])
        this.$store.commit("right/setToken", res.headers.authorization)
        let userInfo = {
          ...res.data.data
        }
        this.$store.commit("right/setUser", JSON.stringify(userInfo))
        this.$store.commit("right/setReminder", false)
        this.$store.commit("right/setRoleLit", res.data.data['roles'])
        // saveDataToLocalStorage('EVALUATORS', false)
        // const response = await getEvaluators()
        // if(response.code === 200){
        //   if(response.data.map(item=>item.name).includes(res.data.data['realName']) || ['ADMIN','MANAGER'].includes(res.data.data['roles'][0])){
        //     saveDataToLocalStorage('EVALUATORS', true)
        //   }
        // }
        await this.$router.push(targetRoute);
      }catch (error) {
        console.log(error);
      } finally {
        window.location.reload();
      }
    }
  }
}
</script>

<style scoped>

.login-page {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  height: 100vh; /* 让整个页面高度填满视口 */
  margin: 0; /* 去除默认的 margin */
  background-color: #f5f5f5; /* 背景颜色 */
}

.login-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding-top: 8%;
}


.login-container {
  border-radius: 10px;
  margin: 0 auto; /* 垂直居中不需要 margin */
  width: 450px;
  padding: 30px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  text-align: left;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
  position: fixed; /* 使用 fixed 定位 */
  top: 50%; /* 垂直方向居中 */
  left: 50%; /* 水平方向居中 */
  transform: translate(-50%, -50%); /* 使用 transform 进行平移，使容器居中 */
}

.login {
  display: grid;
  place-items: center;
}

.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}

.remember {
  margin: 0px 0px 35px 0px;
}

.code-box {
  text-align: right;
}

.codeimg {
  height: 40px;
}


/*v-input输入框placeholder字体*/
::v-deep input::-webkit-input-placeholder {
  -webkit-text-fill-color: #c6d3e5;
}

::v-deep input::-ms-input-placeholder {
  -webkit-text-fill-color: #c6d3e5;
}

::v-deep .form-item-remember .el-form-item__label {
  width: 55px !important;
}

.system-title {
  height: 40px;
  line-height: 40px;
  margin-bottom: 25px;
  text-align: center;
  font-weight: 600;
}

::v-deep .el-tabs__nav-scroll {
  margin: 0 auto !important;
  width: 50%;

}

.head {
  display: flex;
  justify-content: space-between;
}

.login-form {
  margin-top: 10px !important;
}
.m-content-display {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

</style>
